<template lang="pug">
  CommonLoadBox(:loaded="loaded")
    template(slot='skeleton')
      .exchange-list-skeleton-area(:class="{ 'pure-version': pureVersion }")
        ExchangeListSkeleton
    template(slot='module')
      Exchange(
        :bounty="bounty"
        :points="points"
        :tab="tab"
        :tabs="tabs"
        :newModule="newModule"
        :pureVersion="pureVersion"
        @bounty="handleBounty"
        @hideTab="handleHideTab"
        @loaded="handleLoaded"
        @earnPoints="handleAnchorModule"
      )
</template>

<script>
import eventBus from '@/const/eventBus';
import { env } from '@hb/NBridge/lib/h5';
import CommonLoadBox from '@/components/common-load-box';
import ExchangeListSkeleton from '../skeleton-cpns/exchange-list-skeleton';
import Exchange from './exchange-list';
import { TABS } from '../consts';
import { anchorToModule } from '../common/helper';

export default {
  name: 'ExchangeList',
  components: {
    CommonLoadBox,
    ExchangeListSkeleton,
    Exchange,
  },
  props: {
    bounty: {
      type: Number,
      default: 0,
    },
    points: {
      type: Number,
      required: true,
    },
    tab: {
      type: Number,
      default: null,
    },
    tabs: {
      type: Array,
      default: () => TABS,
    },
    newModule: {
      type: Boolean,
      default: false,
    },
    rewardGuidingRules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 是否加载完成
      loaded: false,
      // 锚点定时器
      anchorTimer: null,
      // 兑换引导信息
      guideInfo: {},
    };
  },
  inject: ['isPureVersion'],
  computed: {
    // 是否是纯净版页面
    pureVersion() {
      return this.isPureVersion();
    },
  },
  mounted() {
    eventBus.$on('earnPointsAnchor', () => {
      this.handleAnchorModule();
    });
  },
  beforeDestroy() {
    eventBus.$off('earnPointsAnchor');
  },
  methods: {
    handleBounty() {
      this.$emit('bounty');
    },
    handleHideTab() {
      this.$emit('hideTab');
    },
    handleLoaded() {
      this.loaded = true;
    },
    // 锚点模块
    handleAnchorModule(num) {
      // 小程序端固定锚定到做任务模块
      if (!env.isEasyBikeApp) {
        this.guideInfo = {
          anchoringModuleKey: 'welfare_task_new',
          guidingDesc: '做任务赚奖励金',
        };
        this.anchorTimer = anchorToModule(this.guideInfo, this.anchorTimer);
        return;
      }
      this.guideInfo = this.getGuideInfo(num || this.points);
      this.anchorTimer = anchorToModule(this.guideInfo, this.anchorTimer);
    },
    // 根据积分匹配引导规则
    getGuideInfo(num) {
      return this.rewardGuidingRules.find((item) => {
        if (item.maxNumber === -1) {
          return item.minNumber <= num;
        }
        return item.minNumber <= num && num <= item.maxNumber;
      }) || {};
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-list-skeleton-area {
  margin-top: 0.12rem;

  &.pure-version {
    margin-top: 0;
  }
}
</style>
